<template>
  <div id="TopicVoteWay_main">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            選擇表決計票方式
          </div>
        </div>
      </div>
      <div class="cotent">
        <div class="voteWay">
          <div
            class="way"
            @click="startVote(false)"
          >
            記名投票
          </div>
          <div class="info">
            可計算人數、區權佔比，<br>適合每戶掃描投票
          </div>
        </div>
        <div class="voteWay">
          <div
            class="way"
            @click="startVote(true)"
          >
            不記名投票
          </div>
          <div class="info">
            僅計算投票人數，<br>適合舉手表決
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    return {
      isAnonymous: null // 不記名:true , 記名:false
    }
  },
  mounted () {
    previousPage = { name: 'AssemblyRegister', params: { id: this.$route.params.id } } // header 上一頁路徑
  },
  methods: {
    startVote (way) {
      apiUnitOwnerAssembly.Topic.StartVoting(
        {
          assemblyId: this.$route.params.id,
          topicId: this.$route.params.topicId,
          isAnonymous: way
        }
      ).then(res => {
        // eslint-disable-next-line eqeqeq
        if (res.status == 200) {
          if (way) { // 進入匿名投票
            this.$router.replace({ name: 'NotRecordNameVoting', params: { id: this.$route.params.id, topicId: this.$route.params.topicId } })
          } else { // 進入記名投票
            this.$router.replace({ name: 'RecordNameVoting', params: { id: this.$route.params.id, topicId: this.$route.params.topicId } })
          }
        }
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
        // eslint-disable-next-line eqeqeq
        if (err.response && err.response.status == 400) {
          if (err.response.data.description.indexOf('voting') !== -1) { this.$message.warning('此議案已開始投票') } else if (err.response.data.description.indexOf('decided') !== -1) { this.$message.warning('此議案已結束投票') }
        }
      })
    }
  }
}
</script>
<style lang='sass' scoped>
#TopicVoteWay_main
  +mainLayer
  .cotent
    padding: 50px 0
    width: 500px
    margin: 0 auto
    display: flex
    .voteWay
      flex: 1
      .way
        cursor: pointer
        box-shadow: 0px 0px 5px 0px rgba(0,0,0,0.3)
        margin: 15px
        width: 220px
        height: 220px
        border-radius: $pageBorderRadius
        line-height: 220px
        font-size: 30px
        &:hover
          background-color: $whiteHover
      .info
        font-size: 16px
        line-height: 24px
</style>
